import { render, staticRenderFns } from "./EventBanner.vue?vue&type=template&id=0a18f339&scoped=true&"
import script from "./EventBanner.vue?vue&type=script&lang=js&"
export * from "./EventBanner.vue?vue&type=script&lang=js&"
import style0 from "./EventBanner.vue?vue&type=style&index=0&id=0a18f339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18f339",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex})
